import ko from 'knockout';
import viewModel from './top-list-panel.vm';
import templateMarkup from 'raw-loader!./top-list-panel.template.html';
    
    ko.components.register('assurance-top-list-panel', { template: templateMarkup, viewModel: viewModel });

